// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsRemoveFromSpamDesktopRequest,
  TChatsRemoveFromSpamDesktopModel,
  IMappers,
  TChatsRemoveFromSpamDesktopResponse,
  TChatsRemoveFromSpamDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createChatsRemoveFromSpamDesktopModel(
  parameters: TChatsRemoveFromSpamDesktopRequest,
): TChatsRemoveFromSpamDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/remove-from-spam-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsRemoveFromSpamDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsRemoveFromSpamDesktopRequest;
}

export async function fetchChatsRemoveFromSpamDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsRemoveFromSpamDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsRemoveFromSpamDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsRemoveFromSpamDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsRemoveFromSpamDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsRemoveFromSpamDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsRemoveFromSpamDesktopResponse>;
}
